import ProvidersCreator from '@shared/components/Providers';
import createStore from './store';

const Providers = ProvidersCreator(createStore, {
  isPublic: true,
  withRouter: false,
  withStyles: false
});

export {Providers};
